module.exports = __webpack_public_path__ + "img/30_35.f8347526.png";